import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@unibyte/contracts/locales';
import { el } from './dictionaries/el.js';
import { en } from './dictionaries/en.js';
import { fr } from './dictionaries/fr.js';
import { WIDGET_KEYS } from './keys.js';
export { WIDGET_KEYS } from './keys.js';
export { ADMIN_KEYS, ADMIN_LOCALES, DEFAULT_ADMIN_LOCALE, adminDictionaries, findMissingAdminKeys, isAdminLocale, tAdmin, } from './admin.js';
export const dictionaries = { el, en, fr };
export function getDictionary(locale) {
    return dictionaries[locale];
}
/**
 * Translate a key. Falls back to the default locale, then to the key itself,
 * so a missing translation is visible instead of silently blank.
 */
export function t(locale, key, params) {
    const template = dictionaries[locale]?.[key] ?? dictionaries[DEFAULT_LOCALE][key] ?? key;
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (_m, name) => String(params[name] ?? `{${name}}`));
}
/**
 * Used by tests and the build to guarantee every locale has every key with a non-empty value.
 */
export function findMissingKeys(input = dictionaries) {
    const reports = [];
    const known = new Set(WIDGET_KEYS);
    for (const locale of SUPPORTED_LOCALES) {
        const dict = input[locale] ?? {};
        const missing = WIDGET_KEYS.filter((key) => !(key in dict));
        const empty = WIDGET_KEYS.filter((key) => key in dict && dict[key]?.trim() === '');
        const unknown = Object.keys(dict).filter((key) => !known.has(key));
        if (missing.length > 0 || empty.length > 0 || unknown.length > 0) {
            reports.push({ locale, missing, empty, unknown });
        }
    }
    return reports;
}
//# sourceMappingURL=index.js.map